import React from 'react';

const ReferralIconV2 = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.9993 6.66667H9.33268C8.62544 6.66667 7.94716 6.94762 7.44706 7.44772C6.94697 7.94781 6.66602 8.62609 6.66602 9.33333V25.3333C6.66602 26.0406 6.94697 26.7189 7.44706 27.219C7.94716 27.719 8.62544 28 9.33268 28H22.666C23.3733 28 24.0515 27.719 24.5516 27.219C25.0517 26.7189 25.3327 26.0406 25.3327 25.3333V9.33333C25.3327 8.62609 25.0517 7.94781 24.5516 7.44772C24.0515 6.94762 23.3733 6.66667 22.666 6.66667H19.9993M11.9993 6.66667C11.9993 5.95942 12.2803 5.28115 12.7804 4.78105C13.2805 4.28095 13.9588 4 14.666 4H17.3327C18.0399 4 18.7182 4.28095 19.2183 4.78105C19.7184 5.28115 19.9993 5.95942 19.9993 6.66667M11.9993 6.66667C11.9993 7.37391 12.2803 8.05219 12.7804 8.55229C13.2805 9.05238 13.9588 9.33333 14.666 9.33333H17.3327C18.0399 9.33333 18.7182 9.05238 19.2183 8.55229C19.7184 8.05219 19.9993 7.37391 19.9993 6.66667M18.666 14.6667H15.3327C14.8022 14.6667 14.2935 14.8774 13.9185 15.2525C13.5434 15.6275 13.3327 16.1362 13.3327 16.6667C13.3327 17.1971 13.5434 17.7058 13.9185 18.0809C14.2935 18.456 14.8022 18.6667 15.3327 18.6667H16.666C17.1964 18.6667 17.7052 18.8774 18.0802 19.2525C18.4553 19.6275 18.666 20.1362 18.666 20.6667C18.666 21.1971 18.4553 21.7058 18.0802 22.0809C17.7052 22.456 17.1964 22.6667 16.666 22.6667H13.3327M15.9993 22.6667V24M15.9993 13.3333V14.6667",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
ReferralIconV2.displayName = "Icons.ReferralIconV2";

export { ReferralIconV2 };
//# sourceMappingURL=ReferralIconV2.js.map
